/**
 * Returns true if the current user has an id_token cookie set.
 *
 * Currently all Big Egg One Graph calls require an id_token (except CMS),
 * so this function can be used do defer making GraphQL requests
 * that will definitely fail. Future OneAuth work will give the FE
 * more insights into the user's auth state.
 */
export var getIsAuthenticated = function getIsAuthenticated(ssrCookies) {
  var cookies = ssrCookies || '';
  if (typeof document !== 'undefined') cookies = document.cookie;
  return cookies.split('id_token=').length === 2;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/utils/getIsAuthenticated.js
// module id = 5220
// module chunks = 11